var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5DC9297-6B52-4E43-88F8-EA96CEEFD855") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-1063.000000, -1253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_Search",
    transform: "translate(1063.000000, 1253.442017)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6370981,4.68290188 C20.9070079,7.95281167 21.1879032,13.0798569 18.4797841,16.6688341 L22.0943373,20.2824787 C23.0371463,21.2252878 21.6229328,22.6395013 20.6801237,21.6966923 L17.1082385,18.1265242 C13.5093695,21.2060929 8.08875463,21.0429509 4.68290188,17.6370981 C1.10569937,14.0598956 1.10569937,8.2601044 4.68290188,4.68290188 C8.2601044,1.10569937 14.0598956,1.10569937 17.6370981,4.68290188 Z M6.09711545,6.09711545 C3.30096152,8.89326938 3.30096152,13.4267306 6.09711545,16.2228846 C8.89326938,19.0190385 13.4267306,19.0190385 16.2228846,16.2228846 C19.0190385,13.4267306 19.0190385,8.89326938 16.2228846,6.09711545 C13.4267306,3.30096152 8.89326938,3.30096152 6.09711545,6.09711545 Z",
    id: "Combined-Shape",
    fill: "#92929D"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.20e3ff2f6b0ff2a8c7930caa20242aca.svg";
export { ForwardRef as ReactComponent };